import { MutableRefObject, useEffect } from 'react';
import YouTube from 'react-youtube';

import { songVolumeToPlayerVolume } from '~/modules/songs/utils/song-volume';

/** `volume` is a song's stored 0-1 multiplier, not the player's 0-100 - see `song-volume`. */
export default function usePlayerVolume(playerRef: MutableRefObject<YouTube | null>, volume: number | undefined) {
  useEffect(() => {
    playerRef.current?.getInternalPlayer()?.setVolume(songVolumeToPlayerVolume(volume));
  }, [playerRef, volume]);
}
